import { ApiClient, handleJSONResponse } from './common';
import { BehaviorSubject } from 'rxjs';

export interface UploadStartResponse {
  id: string;
  key: string;
  url: string;
  formData: any;
}

export interface UploadS3Response {
  progress: BehaviorSubject<number>;
  request: Promise<null>;
  cancel: () => void;
}

export interface UploadResponse {
  id: string;
  url: string;
  key: string;
  upload: UploadS3Response;
}

export interface UploadStartRequest {
  filename: string;
  contentType: string;
}

export const startUpload = async <Req = {}, Res = {}>(
  data: Req & UploadStartRequest,
  callAPI: ApiClient,
  endpoint: string,
  signal?: AbortSignal
): Promise<Res & UploadStartResponse> => {
  const response = await callAPI(endpoint, 'POST', data, signal);

  return await handleJSONResponse(response);
};

export const uploadToS3 = (file: File, form: any): UploadS3Response => {
  const data = new FormData();

  Object.keys(form.fields).forEach((k) => data.append(k, form.fields[k]));
  data.append('file', file);

  const progress = new BehaviorSubject(0);
  const xhr = new XMLHttpRequest();

  const cancel = () => {
    xhr.abort();
  };

  const request = new Promise<null>((resolve, reject) => {
    xhr.open('POST', form.url);

    xhr.upload.addEventListener('load', () => resolve(null));
    xhr.upload.addEventListener('abort', () => reject('ASSET.UPLOAD_CANCELED'));
    xhr.upload.addEventListener('error', () => reject());
    xhr.upload.addEventListener('progress', (p) => {
      if (p.total && p.loaded) {
        const percent = Math.floor((p.loaded / p.total) * 100);
        progress.next(percent);
      }
    });

    xhr.send(data);
  });

  return {
    progress,
    request,
    cancel,
  };
};
